import React from 'react'

export default function ProgressandAnalyticsTable({ studentData }) {
  return (
    <div className='px-4'>
      <div className="overflow-x-auto border border-[#7175761A] rounded-[10px] mt-4">
        <table className="w-full min-w-[800px] text-left border-collapse">
          <thead className="text-gray-700 text-sm ">
            <tr>
              <th className="py-4 px-3 font-semibold uppercase">Students</th>
              <th className="py-4 px-3 font-semibold uppercase">Applications</th>
              <th className="py-4 px-3 font-semibold uppercase">Grade(s)</th>
              <th className="py-4 px-3 font-semibold uppercase">Avg Score</th>
              <th className="py-4 px-3 font-semibold uppercase">Usage hours</th>
              <th className="py-4 px-3 font-semibold uppercase">Completion</th>
              <th className="py-4 px-3 font-semibold uppercase text-right">Trend</th>
            </tr>
          </thead>
          <tbody>
            {studentData.length > 0 && studentData.map((item, index) => {
              return (
                <tr className="odd:bg-gray-50 even:bg-white border-b border-b-[#F4F4F4] text-sm" key={index}>
                  <td className="py-2 px-3 text-[#717576]">
                    <div className='flex items-center gap-3'>
                      <div>
                        <img src={item.studentImage} alt='avatar' className='w-8 h-8 rounded-full' />
                      </div>
                      <div>
                        <h3 className='text-[15px] text-[#717576] hover:underline cursor-pointer'>{item.studentName}</h3>
                        <p className='text-[12px] text-[#717576] '>ID: {item.studentId}</p>
                      </div>
                    </div>
                  </td>
                  <td className="py-2 px-3 text-[#717576]">
                    <p style={{ width: 'fit-content' }} className='px-4 py-2 rounded-[4px] bg-[#FFA21D1A] text-[#FFA21D]'>{item.application}</p>
                  </td>
                  <td className="py-2 px-3 text-[#717576]">{item.grade}</td>
                  <td className="py-2 px-3 text-[#3C6CBF]">{item.avgScore}</td>
                  <td className="py-2 px-3 text-[#717576]">{item.usagehours}</td>
                  <td className="py-2 px-3 text-[#717576]">{item.completion}</td>
                  <td
                    className="py-2 px-3 text-[#717576] text-right"
                    style={{ textAlign: "-webkit-right" }}
                  >
                    <p
                      onClick={() => {
                        if (item.trend === "Up") {
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        } else if (item.trend === "Down") {
                          window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
                        }
                      }}
                      style={{ width: "fit-content", cursor: "pointer" }}
                      className={`px-4 py-2 rounded-[4px] ${item.trend === "Up"
                          ? "bg-[#16A34A1A] text-[#16A34A]"
                          : "bg-[#7175761A] text-[#717576]"
                        }`}
                    >
                      {item.trend}
                    </p>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
